import React from 'react'
import styled from '@emotion/styled'
import { spacing, fontSize, fontWeight } from '@retailer-platform/shared-components'
import { useDomainMessages } from 'domains/account-management/utils/domain/intl'

export const StyledNotification = styled.div({
  '.header': {
    fontSize: fontSize.X15,
    fontWeight: fontWeight.SEMIBOLD,
    marginBottom: spacing.X8,
  },
  '.content': {
    fontSize: fontSize.X12,
  },
})

export const Notification: React.FunctionComponent<{ header: string; content: string }> = ({
  header,
  content,
}) => (
  <StyledNotification>
    <div className="header">{header}</div>
    <div className="content">{content}</div>
  </StyledNotification>
)

export const SuccessNotification = () => {
  const { headerMessage, contentMessage } = useDomainMessages({
    headerMessage: 'accountManagementDomain.update.notification.success.header',
    contentMessage: 'accountManagementDomain.update.notification.success.content',
  })

  return <Notification header={headerMessage} content={contentMessage} />
}

export const ErrorNotification = () => {
  const { headerMessage, contentMessage } = useDomainMessages({
    headerMessage: 'accountManagementDomain.update.notification.error.header',
    contentMessage: 'accountManagementDomain.update.notification.error.content',
  })

  return <Notification header={headerMessage} content={contentMessage} />
}
